module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-9.b52fcf6f.png";